import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/half-phones.png'


const _withScopeId = n => (_pushScopeId("data-v-79a7ebe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "migrate-banner"
}
const _hoisted_2 = { class: "migrate-banner-inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "img-box-inner" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Mobile app"
    })
  ])
], -1))
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "banner-title" }
const _hoisted_6 = {
  key: 0,
  class: "banner-desc"
}
const _hoisted_7 = { class: "banner-data" }
const _hoisted_8 = { class: "banner-title" }
const _hoisted_9 = {
  key: 0,
  class: "banner-desc"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "chevrone" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return ($setup.showMigrateBanner)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("a", {
            class: "banner-data-mobile",
            href: $setup.destinationLink,
            target: "_blank"
          }, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString($setup.isMigratedToApp ? "PLEASE USE MOBILE APP INSTEAD" : "CLUBHOUSE IS NOW ON MOBILE!"), 1),
            ($setup.isMigratedToApp)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Since you transitioned to the mobile app to access the main functionality, please use the app."))
              : _createCommentVNode("", true)
          ], 8, _hoisted_4),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h5", _hoisted_8, _toDisplayString($setup.isMigratedToApp ? "PLEASE USE MOBILE APP INSTEAD" : "CLUBHOUSE IS NOW ON MOBILE!"), 1),
            ($setup.isMigratedToApp)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Since you transitioned to the mobile app to access the main functionality, please use the app."))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            class: "button default primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isOpenWeProposeModal = true))
          }, _toDisplayString($setup.isMigratedToApp ? "Open" : "Get") + " the app", 1),
          _createVNode(_component_router_link, {
            class: "primary-mobile",
            to: { name: 'OpenMobileApp' }
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        ($setup.isOpenWeProposeModal)
          ? (_openBlock(), _createBlock($setup["WeProposeOurAppModal"], {
              key: 0,
              "is-open": $setup.isOpenWeProposeModal,
              onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.isOpenWeProposeModal = false))
            }, null, 8, ["is-open"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}